import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatLegacyCheckboxChange as MatCheckboxChange } from '@angular/material/legacy-checkbox';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatDrawer } from '@angular/material/sidenav';
import { ActivatedRoute, Data, NavigationStart, Router } from '@angular/router';
import { FullCalendarComponent } from '@fullcalendar/angular';
import { Calendar as FullCalendar, CalendarOptions, EventClickArg, EventSourceInput } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import listPlugin from '@fullcalendar/list';
import momentPlugin from '@fullcalendar/moment';
import rrulePlugin from '@fullcalendar/rrule';
import timeGridPlugin from '@fullcalendar/timegrid';
import { Actions, ofActionDispatched, Store } from '@ngxs/store';
import { LookupService } from '@services/lookup.service';
import { LegacyTaskDetailsComponent } from '@shared/modules/legacy-tasks/details/details.component';
import { TaskExportUtilsService } from '@tasks/services/task-export-utils.service';
import { FieldDefsState } from '@state/fields/state';
import { OnDestroyMixin, untilComponentDestroyed } from '@w11k/ngx-componentdestroyed';
import { AccountService } from 'app/core';
import { FeatureFlag, Module, NewPermission, Permission } from 'app/core/enums';
import { FieldDef, QueryConfig, User, UserAssociation } from 'app/core/models';
import { LayoutService } from 'app/layout/layout.service';
import { CalendarService } from 'app/modules/calendar/calendar.service';
import { Calendar, CalendarEvent, CalendarSettings } from 'app/modules/calendar/calendar.types';
import { ProjectsService } from 'app/modules/projects/projects.service';
import { Pipeline, Project } from 'app/modules/projects/projects.types';
import { InviteUserComponent } from 'app/modules/settings/modals/invite-user/invite-user.component';
import { ObjectsManagerState } from 'app/modules/settings/objects-manager/state/state';
import { SelectableFieldDef } from 'app/shared/components/column-selector/column-selector.types';
import { RelatedToType } from 'app/shared/enums';
import { OriginalStates } from 'app/shared/models';
import { FormatNumberPipe } from 'app/shared/pipes/format-number.pipe';
import UrlUtils from 'app/shared/Utils/url.utils';
import { AccountState } from 'app/state/account/state';
import { UserState } from 'app/state/user/state';
import cloneDeep from 'lodash-es/cloneDeep';
import moment from 'moment';
import { BehaviorSubject, noop, Observable, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, finalize, switchMap } from 'rxjs/operators';
import {
  FilterListItemChangeArgs,
  FilterListItemModel,
  FilterListItemValueModel,
  TsOverlayComponent,
  TsSnackbarService,
} from 'tsui';

import { LegacyTasksTabComponent } from '../../legacy-tasks/tasks.component';
import { LegacyTasksTabService } from '../services/tasks.service';
import { TaskActions } from '@tasks/state/actions';
import { TaskState } from '@tasks/state/state';
import { Task, TaskList, TaskListTemplate, TaskStatus, TaskType } from '../tasks.types';
import { TaskUtils } from '../tasks.utils';
import { defaultTaskTableFields } from './list.constants';
import { Dialog } from '@angular/cdk/dialog';
import { TaskDetailsComponent } from '@tasks/task-details/task-details.component';

@Component({
  selector: 'task-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
})
export class TaskListComponent extends OnDestroyMixin implements OnInit, AfterViewInit, OnDestroy {
  private taskListId: number;
  private taskList$: Observable<TaskList> = this.store
    .select(TaskState.getTaskView)
    .pipe(filter((taskList) => !!taskList));

  private tasks$: Observable<Task[]> = this.store.select(TaskState.getTasks).pipe(filter((tasks) => !!tasks));

  private task$: Observable<Task> = this.store
    .select(TaskState.getCurrentTask)
    .pipe(filter((task) => task?.id !== this.selectedTask?.id));

  private tasksCount: {
    completed?: number;
    incomplete?: number;
    total?: number;
  };
  private viewTitleMemento: string;
  private pipelines: Pipeline[];
  private events: CalendarEvent[] = [];
  private views: any;
  private eventTimeFormat: any;
  private calendarSettings: CalendarSettings;
  private viewInit = false;
  private calendars: Calendar[];
  private event: CalendarEvent;
  private accountUserAssociations: UserAssociation[] = [];
  private filterOptions: { include_keydates: boolean };
  private filterCacheKey: string;
  private _fullCalendarApi: FullCalendar;
  private changeTriggers: Set<string> = new Set();
  private originalStates: OriginalStates;
  private fieldDefs: FieldDef[] = [];
  public taskList: TaskList;
  public tasks: Task[];
  public groupedTasksByStatus: any = {};
  public project: Project;
  public selectedTask: Task;
  public workflowStates: TaskStatus[];
  public routeData: Data;
  public isLoading: boolean = false;
  public tasksView: string = 'list';
  public queryFilters: Partial<QueryConfig.QueryFilters>;
  public searchInputControl: FormControl;
  public view: 'dayGridMonth' | 'timeGridWeek' | 'timeGridDay' | 'listYear';
  public viewTitle: string;
  public calendarOptions: CalendarOptions;
  public userAssociations: UserAssociation[] = [];
  public filteredUserAssociations: UserAssociation[] = [];
  public taskListUserIds: number[] = [];
  public selectedFields: SelectableFieldDef[] = [];
  public taskFieldDefs: FieldDef[];
  public selectedOrder: string[] = [];
  public searchedIds: number[];
  public users: User[];
  public canEditTaskLayout = false;
  public typeFields = new BehaviorSubject<FilterListItemModel[]>([]);
  public filterValueList = new BehaviorSubject<FilterListItemValueModel[]>([]);
  public taskViewsConfig = [
    { name: 'list', tooltip: 'List view', icon: 'reorder' },
    { name: 'gantt', tooltip: 'Gantt view', icon: 'clear_all' },
    { name: 'kanban', tooltip: 'Kanban view', icon: 'view_agenda' },
    { name: 'calendar', tooltip: 'Calendar view', icon: 'calendar_today' },
  ];
  uiTaskRequiredFields = [
    'id',
    'title',
    'assigned_user_id',
    'custom_field_values',
    'children',
    'task_type',
    'workflow_state',
    'is_complete',
    'account_id',
    'expanded',
    'task_list_id',
    'parent_id',
    'rank',
    'num_comments',
    'start_date',
    'due_date',
    'predecessor_summary',
  ];
  canEdit = true;

  @ViewChild('matDrawer', { static: true }) matDrawer: MatDrawer;
  @ViewChild('fullCalendar') private _fullCalendar: FullCalendarComponent;
  @ViewChild('filtersOverlayBox') private _filtersOverlayBox: TsOverlayComponent;
  @ViewChild('userAssociationsOverlayBox') private _userAssociationOverlayBox: TsOverlayComponent;

  get selectedFieldsTable(): FieldDef[] {
    return this.selectedOrder.map((fieldName: string) =>
      this.routeData.taskFieldDefs.find((taskFieldDef: FieldDef) => taskFieldDef.name === fieldName),
    );
  }

  get filterCounter(): number {
    return this.filterValueList?.value?.length || 0;
  }

  constructor(
    private readonly tasksComponent: LegacyTasksTabComponent,
    private readonly _tasksService: LegacyTasksTabService,
    private readonly _projectsService: ProjectsService,
    private readonly _matDialog: MatDialog,
    private readonly dialog: Dialog,
    private readonly _activatedRoute: ActivatedRoute,
    private readonly _snackBar: TsSnackbarService,
    private readonly _router: Router,
    private readonly _formatNumber: FormatNumberPipe,
    private readonly changeDetectorRef: ChangeDetectorRef,
    private readonly calendarService: CalendarService,
    private readonly layoutService: LayoutService,
    private readonly accountService: AccountService,
    private readonly store: Store,
    private readonly actions$: Actions,
    public readonly lookupService: LookupService,
    private readonly taskExportUtilsService: TaskExportUtilsService,
  ) {
    super();
    this.tasksCount = {
      completed: 0,
      incomplete: 0,
      total: 0,
    };
    this.view = 'dayGridMonth';
    this.searchInputControl = new FormControl('');
    this._projectsService.accountId = this.store.selectSnapshot(AccountState.getAccount)?.id;
  }

  private getSelectFieldFromTaskListDef(taskList: TaskList): string {
    const fields = [...(taskList?.definition?.fields ?? defaultTaskTableFields.map(({ name }) => name))];

    const uniqueFields = new Set([...fields, ...this.uiTaskRequiredFields]);

    if (fields.includes('project_id')) {
      uniqueFields.add('project');
      uniqueFields.add('object_name');
    }

    if (fields.includes('property_id')) {
      uniqueFields.add('property');
      uniqueFields.add('object_name');
    }

    return [...uniqueFields].join(',');
  }

  ngOnInit(): void {
    this.canEditTaskLayout = this.store.selectSnapshot(UserState.hasPermission(Permission.TASK_LIST_EDIT_LAYOUT));

    if (this.store.selectSnapshot(AccountState.isFeatureEnabled(FeatureFlag.NEW_PERMISSIONS))) {
      if (this.module === Module.GLOBAL_TASKS) {
      } else {
        this.canEdit = this.store.selectSnapshot(UserState.hasPermission(NewPermission.AGGREGATED_TASK_LISTS_EDIT));
      }
    }

    this.layoutService.emitCommon('fromTaskDetails', null);

    this._tasksService.drawerToggle$.pipe(untilComponentDestroyed(this)).subscribe(() => {
      this.matDrawer.toggle();
    });

    this._activatedRoute.params.pipe(untilComponentDestroyed(this), distinctUntilChanged()).subscribe((params) => {
      this.taskListId = +params.task_list_id;
      this.store.dispatch(new TaskActions.GetTaskListById(this.taskListId, null, true));
    });

    this.actions$
      .pipe(ofActionDispatched(TaskActions.FilterTasks, TaskActions.GetTaskListById), untilComponentDestroyed(this))
      .subscribe((action) => {
        this.isLoading = true;
      });

    this.setFilteredFields();

    // [SC-24187] Listen for task creation and trigger filter method to update the list with the new task.
    this._tasksService.updateListFilter$
      .pipe(
        untilComponentDestroyed(this),
        filter((res) => !!res),
      )
      .subscribe(() => {
        if (this.queryFilters?.fjson?.length && this.queryFilters?.fjson !== '[]') {
          this.applyFilter(this.queryFilters, false);
        }
      });

    this._activatedRoute.data.pipe(untilComponentDestroyed(this)).subscribe((data: Data) => {
      this.routeData = data;
    });

    this.accountService.userAssociations$
      .pipe(untilComponentDestroyed(this))
      .subscribe((userAssociations: UserAssociation[]) => {
        this.accountUserAssociations = userAssociations;
        this.filteredUserAssociations = userAssociations;
        this.users = userAssociations.map((userAssociation) => userAssociation.user);
      });

    this.fillTasksView();

    this.taskList$.pipe(untilComponentDestroyed(this)).subscribe((taskList: TaskList) => {
      this.taskList = taskList;
      this.searchedIds = undefined;
      this.selectedFields = this.getFieldDefsState();
      this.queryFilters = taskList.definition?.filters ? cloneDeep(JSON.parse(taskList.definition.filters)) : {};
      this.filterValueList.next(this.fjsonStringToFilterValue(this.queryFilters?.fjson ?? '[]'));
      this.searchInputControl.patchValue(this.queryFilters?.q || '', { emitEvent: false });
      this.loadTaskListUserAssociations();
      this.refreshSelectedFields();
      this.fillQueryFilters();
      if (this.hasFiltersApplied()) {
        this.applyFilter(this.queryFilters, false);
      }
    });

    this.task$.pipe(untilComponentDestroyed(this)).subscribe((task: Task) => {
      this.selectedTask = task;
      if (task) {
        this.navigateToTask(task.id);
      }
      this.changeDetectorRef.markForCheck();
    });

    this._projectsService.project$.pipe(untilComponentDestroyed(this)).subscribe((project: Project) => {
      this.project = project;
    });

    this._tasksService
      .getTaskStatuses()
      .pipe(untilComponentDestroyed(this))
      .subscribe((taskStatuses) => {
        this.workflowStates = taskStatuses;
      });

    this.tasks$.pipe(untilComponentDestroyed(this)).subscribe((tasks: Task[]) => {
      if (tasks) {
        this.tasks = cloneDeep(TaskUtils.deepSortTasksByRank(tasks));
        this.tasksCount.total = this.tasks.filter((task) => task.task_type === 'task').length;
        this.tasksCount.completed = this.tasks.filter((task) => task.task_type === 'task' && task.is_complete).length;
        this.tasksCount.incomplete = this.tasksCount.total - this.tasksCount.completed;

        const flatTasksArr = TaskUtils.flattenTasks(this.tasks);

        this.groupTasksByStatus(flatTasksArr);
        this.calculatePercentComplete();
        this.isLoading = false;
        this.changeDetectorRef.markForCheck();
      }
    });

    this.calendarService
      .getSettings()
      .pipe(untilComponentDestroyed(this))
      .subscribe((settings) => {
        // Store the settings
        this.calendarSettings = settings;

        // Set the FullCalendar event time format based on the time format setting
        this.eventTimeFormat = {
          hour: settings.timeFormat === '12' ? 'numeric' : '2-digit',
          hour12: settings.timeFormat === '12',
          minute: '2-digit',
          meridiem: settings.timeFormat === '12' ? 'short' : false,
        };

        // Mark for check
        this.changeDetectorRef.markForCheck();
      });

    this.views = {
      dayGridMonth: {
        dayMaxEventRows: 3,
        eventTimeFormat: this.eventTimeFormat,
        fixedWeekCount: false,
      },
      timeGrid: {
        allDayContent: '',
        dayHeaderFormat: {
          weekday: 'short',
          day: 'numeric',
          omitCommas: true,
        },
        dayHeaderContent: (args) => {
          return {
            html: `
              <span class="fc-weekday">${moment(args.date).format('ddd')}</span>
              <span class="fc-date">${moment(args.date).format('D')}</span>
            `,
          };
        },
        slotDuration: '01:00:00',
        slotLabelFormat: this.eventTimeFormat,
      },
      listYear: {
        allDayContent: 'All day',
        eventTimeFormat: this.eventTimeFormat,
        listDayFormat: false,
        listDaySideFormat: false,
      },
    };

    this.calendarOptions = {
      contentHeight: '100%',
      headerToolbar: false,
      handleWindowResize: false,
      firstDay: this.calendarSettings?.startWeekOn,
      eventClick: this.onEventClick.bind(this),
      eventsSet: this.handleEvents.bind(this),
      dateClick: this.onDateClick.bind(this),
      eventDidMount: this.onEventRender.bind(this),
      views: this.views,
      initialView: 'dayGridMonth',
      plugins: [dayGridPlugin, interactionPlugin, listPlugin, momentPlugin, rrulePlugin, timeGridPlugin],
    };

    this.calendarService.events$.pipe(untilComponentDestroyed(this)).subscribe((events: CalendarEvent[]) => {
      if (events) {
        // Clone the events to change the object reference so that the FullCalendar can trigger a re-render.
        this.events = cloneDeep(
          events
            ?.filter(({ related_to_id }) => related_to_id === Number(this.project?.id))
            .map((x) => ({
              ...x,
              end: x.due_date ? moment(x.due_date, moment.ISO_8601).add(1, 'd').format() : null,
              start: x.start_date,
            })),
        );
        this.calendarOptions.events = this.events as EventSourceInput;
        this.changeDetectorRef.markForCheck();
      }
    });

    this._projectsService
      .getPipelines()
      .pipe(untilComponentDestroyed(this))
      .subscribe((pipelines) => {
        if (pipelines) {
          // Store the calendars
          this.pipelines = pipelines;
          this.calendars = this.pipelines.map((pipeline) => {
            return {
              id: pipeline.id,
              title: pipeline.name,
              visible: pipeline.visible,
              color: pipeline?.color || 'gray',
            };
          });
          this.changeDetectorRef.markForCheck();
        }
      });

    this.searchInputWatcher();

    this.fetchCalendarEvents();

    this.matDrawer.openedChange
      .pipe(
        untilComponentDestroyed(this),
        filter((state: boolean) => !state),
      )
      .subscribe(() => {
        this.selectedTask = null;
        if (this._fullCalendar) this._fullCalendar.getApi().updateSize();
      });
  }

  ngAfterViewInit(): void {
    if (UrlUtils.getFromLocalStorage('projectTasksView') === 'calendar') {
      this.loadCalendar();
    }
    this.viewInit = true;
    this.closeSnackBarOnLeave();
  }

  ngOnDestroy(): void {
    this.store.dispatch(new TaskActions.ClearTaskList());
    super.ngOnDestroy();
  }

  private setFilteredFields(): void {
    this.fieldDefs = this.store.selectSnapshot(
      ObjectsManagerState.getFieldsByObjectName(RelatedToType.Task, {
        allowedFieldsOnly: true,
        addNestedFields: false,
      }),
    );
    this.setFilterNestedFields();
  }

  public toggleDrawer(): void {
    this.tasksComponent.drawer.toggle();
  }

  public onUserAssociationPanelClose(element: HTMLInputElement): void {
    element.value = '';
  }

  hasFiltersApplied(): boolean {
    return !!this.queryFilters?.q?.trim() || (this.queryFilters?.fjson?.length && this.queryFilters?.fjson !== '[]');
  }

  private fetchCalendarEvents(): Subscription {
    return this.layoutService
      .getCommon('fromTaskDetails')
      .pipe(
        untilComponentDestroyed(this),
        filter(() => this.tasksView === 'calendar'),
        debounceTime(300),
        switchMap(() => {
          this._fullCalendarApi = this._fullCalendar?.getApi();
          const viewStart = moment(this._fullCalendarApi.view.currentStart).subtract(60, 'days');
          const viewEnd = moment(this._fullCalendarApi.view.currentEnd).add(60, 'days');
          return this.calendarService.getEvents(viewStart, viewEnd, true, {
            objectTypeIn: [RelatedToType.Task],
            assignedUserIdIn: [],
            relatedToType: this.taskList?.related_to_type,
            relatedToId: this.taskList?.related_to_id,
          });
        }),
        finalize(() => this._fullCalendarApi.render()),
      )
      .subscribe(noop);
  }

  private loadCalendar(): void {
    // Get the full calendar API
    this._fullCalendarApi = this._fullCalendar?.getApi();

    // Get the current view's title
    this.viewTitle = this._fullCalendarApi.view.title;
    this.viewTitleMemento = this.viewTitleMemento ?? this.viewTitle;

    // Get the view's current start and end dates, add/subtract
    // 60 days to create a ~150 days period to fetch the data for
    const viewStart = moment(this._fullCalendarApi.view.currentStart).subtract(60, 'days');
    const viewEnd = moment(this._fullCalendarApi.view.currentEnd).add(60, 'days');

    // Get events
    this.calendarService
      .getEvents(viewStart, viewEnd, true, { objectTypeIn: [RelatedToType.Task], assignedUserIdIn: [] })
      .pipe(untilComponentDestroyed(this))
      .subscribe();
  }

  public onDatesRender(): void {
    if (this.viewInit) {
      setTimeout(() => this.loadCalendar(), 0);
    }
  }

  public changeTasksView(taskView: string): void {
    this.tasksView = taskView;
    this.saveTasksView(this.tasksView);
    this.viewTitle = this.viewTitleMemento;
    this.renderCalendarOnViewChange(taskView);
  }

  private renderCalendarOnViewChange(taskView: string): void {
    if (taskView === 'calendar') {
      this.fetchCalendarEvents();
    }
  }

  public refreshTasks(): void {
    this.store.dispatch(new TaskActions.RecalculateTaskListDates(this.taskListId));
  }

  private onDateClick(dateClick): void {
    // Prepare the event
    const event = {
      id: null,
      calendarId: this.calendars[0].id,
      recurringEventId: null,
      isFirstInstance: false,
      title: '',
      description: '',
      start: moment(dateClick.date).startOf('day').toISOString(),
      end: moment(dateClick.date).endOf('day').toISOString(),
      duration: null,
      allDay: true,
      recurrence: null,
      range: {
        start: moment(dateClick.date).startOf('day').toISOString(),
        end: moment(dateClick.date).endOf('day').toISOString(),
      },
    };

    // Set the event
    this.event = event;

    // Set the el on dateClick for consistency
    dateClick.el = dateClick.dayEl;
  }

  private onEventClick(eventClick: EventClickArg): void {
    this.navigateToTask(+eventClick.event.id);
  }

  private handleEvents(events: CalendarEvent[]) {
    this.events = events;
    this.changeDetectorRef.detectChanges();
  }

  public onEventRender(calendarEvent): void {
    // Get event's calendar
    const calendar = this.calendars.find((item) => item.id === calendarEvent.event.extendedProps.calendarId);

    // Return, if the calendar doesn't exist...
    if (!calendar) {
      return;
    }

    // If current view is year list...
    if (this.view === 'listYear') {
      // Create a new 'fc-list-item-date' node
      const fcListItemDate1 = `
        <td class="fc-list-item-date">
          <span>
            <span>${moment(calendarEvent.event.start).format('D')}</span>
            <span>${moment(calendarEvent.event.start).format('MMM')}, ${moment(calendarEvent.event.start).format('ddd')}
            </span>
          </span>
        </td>`;

      // Insert the 'fc-list-item-date' into the calendar event element
      calendarEvent.el.insertAdjacentHTML('afterbegin', fcListItemDate1);

      // Set the color class of the event dot
      calendarEvent.el.getElementsByClassName('fc-list-event-dot')[0].classList.add(calendar.color);

      // Set the event's title to '(No title)' if event title is not available
      if (!calendarEvent.event.title) {
        calendarEvent.el.querySelector('.fc-list-event-title').innerText = '(No title)';
      }
    }
    // If current view is not month list...
    else {
      // Set the color class of the event
      const event = this.events.find((x) => x.id === Number(calendarEvent.event.id));
      if (event) {
        switch (event.workflow_state) {
          case 'n_a':
          case 'not_started':
            calendarEvent.el.classList.add('gray');
            break;
          case 'needs_review':
            calendarEvent.el.classList.add('red');
            break;
          case 'in_progress':
            calendarEvent.el.classList.add('blue');
            break;
          case 'complete':
            calendarEvent.el.classList.add('green');
            break;
          default:
            calendarEvent.el.classList.add(calendar.color);
            break;
        }
      } else {
        calendarEvent.el.classList.add(calendar.color);
      }

      // Set the event's title to '(No title)' if event title is not available
      if (!calendarEvent.event.title) {
        calendarEvent.el.querySelector('.fc-title').innerText = '(No title)';
      }
    }

    // Set the event's visibility
    calendarEvent.el.style.display = calendar.visible ? 'flex' : 'none';
  }

  public navigateToTask(taskId: number, fragment?: string): void {
    // this.toggleDrawer(); KOEEP IT ??
    if (this.isTaskSelected) {
      this._router.navigateByUrl(this.previousRouteUrl + '/' + taskId + (fragment ? `#${fragment}` : ''));
    } else {
      this._router.navigate(['./', taskId], { relativeTo: this.route, ...(fragment ? { fragment } : {}) });
    }
  }

  public onNavigateToTaskComment({ id }: Task) {
    this.navigateToTask(id, TaskDetailsComponent.commentViewFragment);
  }

  private get isTaskSelected(): boolean {
    return this.selectedTask?.id && this.matDrawer?.opened;
  }

  private get route(): ActivatedRoute {
    let route = this._activatedRoute;
    while (route.firstChild) {
      route = route.firstChild;
    }
    return route;
  }

  private get previousRouteUrl(): string {
    let url: any = this._router.url.split('/');
    url.pop();
    return url.join('/');
  }

  private calculatePercentComplete(): void {
    let sections = this.tasks.filter((task) => task.task_type === 'section');

    for (let section of sections) {
      let childTasks = section.children;
      let closedChildTasks = childTasks.filter((task) => task.workflow_state == 'complete');
      section.num_children = childTasks.length;
      section.num_closed_children = closedChildTasks.length;
      section.num_open_children = childTasks.length - closedChildTasks.length;

      if (childTasks.length > 0) {
        section.percent_complete = this._formatNumber.transform(
          ((closedChildTasks.length / childTasks.length) * 100).toString(),
          0,
        );
      } else {
        section.percent_complete = 0;
      }
    }
  }

  private groupTasksByStatus(tasks: Task[]): void {
    this.groupedTasksByStatus = {};

    for (let worflow of this.workflowStates) {
      const results = tasks.filter((task) => task.workflow_state == worflow.key && task.task_type == 'task');
      this.groupedTasksByStatus[worflow.key] = results;
    }
  }

  public getTaskStatusLabel(statusKey): string {
    if (!statusKey) {
      return;
    }
    let statusLabel = '';
    let foundStatus = this.workflowStates.find((taskStatus) => taskStatus.key === statusKey);
    if (foundStatus) {
      statusLabel = foundStatus.label;
    }
    return statusLabel;
  }

  public updateTask(task: Task): void {
    this.store.dispatch(new TaskActions.UpdateTask(task));
  }

  public deleteTask(taskId: number): void {
    this.store.dispatch(new TaskActions.DeleteTask(this.taskList?.id, taskId));
  }

  private saveTasksView(view: string): void {
    UrlUtils.saveToLocalStorage('projectTasksView', view);
  }

  private fillTasksView(): void {
    const cachedTasksView = UrlUtils.getFromLocalStorage('projectTasksView');
    if (cachedTasksView) {
      this.tasksView = cachedTasksView;
    }
  }

  private saveQueryFilters(filters: Partial<QueryConfig.QueryFilters>): void {
    UrlUtils.saveToLocalStorage(this.filterCacheKey, filters, true);
  }

  public droppedKanban(event: CdkDragDrop<any[]>): void {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data, event.container.data, event.previousIndex, event.currentIndex);
      const updatedTask = event.item.data;
      updatedTask.workflow_state = event.container.id;
      this.updateTask(updatedTask);
    }
    this.changeDetectorRef.markForCheck();
  }

  private resetTaskOrder(task: Task, tasks: Task[]): void {
    let index = 0;
    for (let task of tasks) {
      task.rank = index;
      index += 1;
    }

    this._tasksService
      .updateTasksOrders(this.taskList, tasks)
      .pipe(untilComponentDestroyed(this))
      .subscribe(() => {
        if (task) {
          let latest = document.getElementById('task-' + task.id);
          if (latest) latest.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
        }
      });
  }

  public onOrderChanged(changedTasks: Task[]): void {
    this.store.dispatch(new TaskActions.ReorderTasks(this.taskList.id, changedTasks));
  }

  public createTask(model: { taskType: TaskType; parentId?: number; rank?: number }): void {
    this.store.dispatch(new TaskActions.CreateTask(model));
  }

  public downloadTasks(format: 'csv' | 'pdf' = 'csv'): void {
    this._tasksService
      .getTasks(this.taskList?.id || this.taskListId, null, {}, format, true, this.selectedOrder.join(','))
      .pipe(untilComponentDestroyed(this))
      .subscribe((data: any) => this.taskExportUtilsService.handleTaskExport(data, format, this.taskList?.name));
  }

  public updateTaskListTemplate(): void {
    if (this.taskList.task_list_template_id) {
      let taskListTemplate: TaskListTemplate = {};
      taskListTemplate.id = this.taskList.task_list_template_id;
      taskListTemplate.copy_from_task_list_id = this.taskList?.id || this.taskListId;

      this._tasksService
        .updateTaskListTemplate(taskListTemplate)
        .pipe(untilComponentDestroyed(this))
        .subscribe(() => {
          this._snackBar.open('Template updated.', 'success');
        });
    }
  }

  public trackByFn(index: number, item: any): any {
    return item.id || index;
  }

  public changeView(view: 'dayGridMonth' | 'timeGridWeek' | 'timeGridDay' | 'listYear'): void {
    // Store the view
    this.view = view;

    // If the FullCalendar API is available...
    if (this._fullCalendarApi) {
      this._fullCalendarApi.changeView(view);
      this.viewTitle = this._fullCalendarApi.view.title;
      this.viewTitleMemento = this.viewTitle;
    }
  }

  public previous(): void {
    this._fullCalendarApi.prev();
    this.viewTitle = this._fullCalendarApi.view.title;
    const start = moment(this._fullCalendarApi.view.currentStart);
    this.calendarService.prefetchPastEvents(start).pipe(untilComponentDestroyed(this)).subscribe();
  }

  public today(): void {
    this._fullCalendarApi.today();
    this.viewTitle = this._fullCalendarApi.view.title;
  }

  public next(): void {
    this._fullCalendarApi.next();
    this.viewTitle = this._fullCalendarApi.view.title;
    const end = moment(this._fullCalendarApi.view.currentEnd);
    this.calendarService.prefetchFutureEvents(end).pipe(untilComponentDestroyed(this)).subscribe();
  }

  public filterUserAssociations(event: InputEvent): void {
    const value = (event.target as HTMLInputElement).value.toLowerCase();

    this.filteredUserAssociations = this.accountUserAssociations.filter((ua) =>
      ua.user.full_name?.toLowerCase().includes(value),
    );
  }

  public filterUserAssociationsInputKeyDown(event: KeyboardEvent): void {
    if (event.key !== 'Enter') {
      return;
    }

    // sc-29961 there's probably a bug hidden here, we are accessing the index of
    // a method signature.
    const ua = this.filterUserAssociations[0];
    const isFieldVisible = this.userAssociations.find((item) => item.user.full_name === ua.user.full_name);

    if (isFieldVisible) {
      this.removeUserAssociation(ua);
    } else {
      this.addUserAssociation(ua);
    }
  }

  public toggleUserAssociation(userAssociation: UserAssociation, change: MatCheckboxChange): void {
    if (change.checked) {
      this.addUserAssociation(userAssociation);
    } else {
      this.removeUserAssociation(userAssociation);
    }
  }

  private removeUserAssociation(userAssociation: UserAssociation): void {
    const ua = this.userAssociations.find((item) => item.user.id === userAssociation.user.id);
    this._projectsService
      .deleteUserAssociationGeneral(ua)
      .pipe(
        untilComponentDestroyed(this),
        finalize(() => this.loadTaskListUserAssociations()),
      )
      .subscribe();
  }

  private addUserAssociation(userAssociation: UserAssociation): void {
    const ua = {
      related_to_id: this.taskList?.id || this.taskListId,
      related_to_type: RelatedToType.TaskList,
      user_id: userAssociation.user.id,
      role: userAssociation.role,
    };
    this._projectsService
      .createUserAssociationGeneral(ua)
      .pipe(
        untilComponentDestroyed(this),
        finalize(() => this.loadTaskListUserAssociations()),
      )
      .subscribe();
  }

  public openInvitationModal(): void {
    this._userAssociationOverlayBox.closeOverlay();

    this.dialog.open(InviteUserComponent, {
      panelClass: 'mailbox-compose-dialog',
      data: {
        role: 'guest',
        forceRoleName: 'collaborator',
        extra: { task_list_id: this.taskList?.id },
      },
    });
  }

  private loadTaskListUserAssociations(): void {
    this._projectsService
      .getUserAssociationsGeneral('TaskList', this.taskList?.id)
      .pipe(untilComponentDestroyed(this))
      .subscribe((userAssociations) => {
        if (userAssociations) {
          this.userAssociations = userAssociations;
          this.taskListUserIds = this.userAssociations.map((ua) => ua.user.id);
          this.changeDetectorRef.markForCheck();
        }
      });
  }

  public onSaveColumns(selectedFieldDefs: SelectableFieldDef[]): void {
    this.openTrackStateSnackbar('columns');

    this.selectedFields = selectedFieldDefs.length
      ? selectedFieldDefs
      : (defaultTaskTableFields as SelectableFieldDef[]);

    if (!this.selectedFields.find(({ name }) => name === 'title')) {
      this.selectedFields.unshift({
        name: 'title',
        label: 'Title',
        selected: true,
        type: 'text',
      });
    }

    this.selectedOrder = selectedFieldDefs.map(({ name }) => name) || [];

    this.refreshSelectedFields();
  }

  private refreshSelectedFields(): void {
    this.taskFieldDefs = [
      ...this.routeData.taskFieldDefs.map((taskFieldDef: FieldDef) => {
        const selected = !!this.selectedFields.find(
          (selectedField: SelectableFieldDef) => selectedField.name === taskFieldDef.name,
        );

        return {
          ...taskFieldDef,
          selected,
        };
      }),
    ];

    this.selectedOrder = this.selectedFields.map(({ name }) => name) || [];
  }

  private fillQueryFilters(): void {
    // migrating saved filters that doesn't have filterOptions
    if (!Object.keys(this.queryFilters).includes('filterOptions')) {
      this.queryFilters.filterOptions = { include_keydates: false };
      this.saveQueryFilters(this.queryFilters);
    }
    this.filterOptions = this.queryFilters?.filterOptions;
    this.onCloseByBackdropClick();
  }

  private applyFilter(filters: Partial<QueryConfig.QueryFilters>, showLoading = true): void {
    console.log(filters);
    this.store.dispatch(new TaskActions.FilterTasks(this.queryFilters as any));
  }

  private searchInputWatcher(): void {
    this.searchInputControl.valueChanges.pipe(untilComponentDestroyed(this), debounceTime(500)).subscribe((query) => {
      this.openTrackStateSnackbar('filters');
      this.queryFilters.q = query;
      this.applyFilter(this.queryFilters);
    });
  }

  private getDisplayColumnsState(): string[] {
    return this.taskList.definition?.fields;
  }

  private setDisplayColumnsState(value: string[]): void {
    this.originalStates.displayColumns = value;
  }

  private fjsonStringToFilterValue(fjson: string): FilterListItemValueModel[] {
    return JSON.parse(fjson ?? '[]').map(([fieldName, operator, value]) => ({
      fieldName,
      operator,
      value,
    })) as FilterListItemValueModel[];
  }

  private getFieldDefsState(): SelectableFieldDef[] {
    const fields = this.getDisplayColumnsState();
    return fields
      ? fields.map((fieldName: string) =>
          this.routeData.taskFieldDefs.find((taskFieldDef: FieldDef) => taskFieldDef.name === fieldName),
        )
      : defaultTaskTableFields;
  }

  private setFieldDefsState(value: FieldDef[]): void {
    this.originalStates.fieldDefs = value;
  }

  private getFilterValueListState(): FilterListItemValueModel[] {
    return this.fjsonStringToFilterValue(this.queryFilters?.fjson ?? '[]');
  }

  private setFilterValueListState(value: FilterListItemValueModel[]): void {
    this.originalStates.filterValueList = value;
  }

  private getQueryFiltersState(): Partial<QueryConfig.QueryFilters> {
    return JSON.parse(this.taskList.definition?.filters || '{}');
  }

  private setQueryFiltersState(value: Partial<QueryConfig.QueryFilters>): void {
    this.originalStates.queryFilters = value;
  }

  private captureOriginalStates(): void {
    this.originalStates = {
      displayColumns: this.getDisplayColumnsState(),
      fieldDefs: this.getFieldDefsState(),
      queryFilters: { ...this.getQueryFiltersState() },
      filterValueList: this.getFilterValueListState(),
    };
  }

  private openTrackStateSnackbar(changeType: 'filters' | 'columns'): void {
    this.changeTriggers.add(changeType);
    this.captureOriginalStates();
    this._snackBar.openApplyChanges(this.resetToOriginalStates.bind(this), this.saveAllChanges.bind(this));
  }

  private clearChangeTriggers(): void {
    this.changeTriggers.clear();
  }

  private resetToOriginalStates(): void {
    if (this.changeTriggers.has('columns')) {
      this.selectedOrder = this.getDisplayColumnsState();
      this.selectedFields = this.getFieldDefsState();
      this.refreshSelectedFields();
    }

    if (this.changeTriggers.has('filters')) {
      this.queryFilters = this.getQueryFiltersState();
      this.filterValueList.next(this.getFilterValueListState());
      this.searchInputControl.patchValue(this.queryFilters.q || '', { emitEvent: false });
      this.onCloseByBackdropClick();
      if (this.hasFiltersApplied()) {
        this.applyFilter(this.queryFilters);
      } else {
        this.searchedIds = undefined;
        this.changeDetectorRef.detectChanges();
      }
    }

    this.clearChangeTriggers();
    this.changeDetectorRef.markForCheck();
  }

  private saveAllChanges(): void {
    if (this.changeTriggers.has('columns') || this.changeTriggers.has('filters')) {
      this.taskList.definition.fields = this.selectedOrder;
      const newTaskList = {
        ...this.taskList,
        definition: {
          ...this.taskList.definition,
          fields: this.selectedOrder,
          filters: JSON.stringify(this.queryFilters),
        },
      };

      this.store
        .dispatch(new TaskActions.UpdateTaskList(newTaskList))
        .pipe(untilComponentDestroyed(this))
        .subscribe(() => {
          this.setDisplayColumnsState(this.selectedOrder);
          this.setFieldDefsState(this.selectedFieldsTable);
          this.refreshSelectedFields();
        });
    }

    if (this.changeTriggers.has('filters')) {
      this.setQueryFiltersState(this.queryFilters);
      this.setFilterValueListState(this.filterValueList.value);
      this.saveQueryFilters(this.queryFilters);
    }

    this.clearChangeTriggers();
  }

  private closeSnackBarOnLeave(): void {
    this._router.events
      .pipe(
        untilComponentDestroyed(this),
        filter((route) => route instanceof NavigationStart),
      )
      .subscribe(() => this._snackBar.dismiss());
  }

  private formatFieldOptions(meta: any): string[] | { label: string; value: string }[] {
    const dropdownOptions = this.store.selectSnapshot(FieldDefsState.selectDropdownOptionsBy(meta?.option_name));

    if (dropdownOptions) {
      return dropdownOptions.map((option) => ({ label: option.name, value: option.id }));
    }

    return meta?.options || [];
  }

  private setFilterNestedFields(): void {
    const allfields = this.fieldDefs.map((x) => ({
      ...x,
      meta: { ...x.meta, group: { key: 'Task', label: 'Task' } },
    }));

    this.typeFields.next(
      allfields.map(({ label, name, type, meta }) => {
        const fieldOptions = this.formatFieldOptions(meta);

        return {
          label,
          name,
          meta: {
            filtering: { operators: meta?.filtering?.operators || [], functions: meta?.filtering?.functions || [] },
            options: fieldOptions,
            multi_select: meta?.multi_select || false,
            record_type: meta?.record_type || null,
            group: meta?.group,
            scale: meta?.scale,
          },
          type,
        } as FilterListItemModel;
      }),
    );
  }

  public onCloseByBackdropClick(): void {
    this.filterValueList.next(this.fjsonStringToFilterValue(this.queryFilters?.fjson ?? '[]'));
  }

  public onAddFilterItem(): void {
    this.filterValueList.next([
      ...this.filterValueList.value,
      {
        fieldName: null,
        operator: null,
        value: null,
      },
    ]);
  }

  public onFilterDefChanged(filterDefChangeArgs: FilterListItemChangeArgs): void {
    const index = filterDefChangeArgs.index;
    delete filterDefChangeArgs.index;
    this.filterValueList.value[index] = filterDefChangeArgs;
    this.filterValueList.next([...this.filterValueList.value]);
  }

  public onFilterRemoved(index: number): void {
    const newState = this.filterValueList.value?.filter((_, i) => i !== index);
    if (!newState.length) {
      this.onFilterCleared();
    }
    this.filterValueList.next(newState);
  }

  public onFilterCleared(): void {
    this.openTrackStateSnackbar('filters');
    this.filterValueList.next([]);
    this.queryFilters = { ...this.queryFilters, fjson: `[]` };
    this.store.dispatch(new TaskActions.ClearFilter());
  }

  public onFilterApplied(): void {
    this.openTrackStateSnackbar('filters');
    this.queryFilters = {
      ...this.queryFilters,
      fjson: `[${this.filterValueList.value
        .map((x) => `["${x.fieldName}", "${x.operator}", ${JSON.stringify(x.value)}]`)
        .join(', ')}]`,
    };

    this.applyFilter(this.queryFilters);
    this._filtersOverlayBox.closeOverlay();
  }

  public openTaskExportDialog() {
    this.taskExportUtilsService
      .openTaskExportDialog()
      .pipe(untilComponentDestroyed(this))
      .subscribe((result) => {
        this.downloadTasks(result);
      });
  }

  getTaskListSharingRecordsPermission(): NewPermission | boolean {
    if (!this.store.selectSnapshot(AccountState.isFeatureEnabled(FeatureFlag.NEW_PERMISSIONS))) {
      return 'TASK_LIST_ADD_USER' as NewPermission;
    }

    if (this.module === Module.GLOBAL_TASKS) {
      return NewPermission.GLOBAL_TASKS_SHARING_RECORDS;
    } else {
      return NewPermission.AGGREGATED_TASKS_SHARING_RECORDS;
    }
  }

  get module(): string | undefined {
    return this._activatedRoute.snapshot.data?.module;
  }
}
